import angular from 'angular';
import template from './toggle-view-button.html';
const SHOW_TOOLTIP_TIMEOUT = 5000;
const GALLERY_VIEW_TOOLTIP_PROPERTY = 'was-gallery-view-tooltip-shown';
class CallActionsToggleViewButtonController {
    constructor($timeout) {
        this.$timeout = $timeout;
    }
    $onInit() {
        this.updateGalleryViewTooltipVisibility({ isShown: false });
        if (!this.isPatient && !this.wasGalleryViewTooltipShown()) {
            if (!this.isGalleryView) {
                this.galleryViewTooltipWatcher = this.$timeout(() => {
                    if (!this.isGalleryView) {
                        this.updateGalleryViewTooltipVisibility({ isShown: true });
                    }
                    window.localStorage.setItem(GALLERY_VIEW_TOOLTIP_PROPERTY, 'true');
                }, SHOW_TOOLTIP_TIMEOUT);
            }
            else {
                window.localStorage.setItem(GALLERY_VIEW_TOOLTIP_PROPERTY, 'true');
            }
        }
    }
    wasGalleryViewTooltipShown() {
        return (window.localStorage.getItem(GALLERY_VIEW_TOOLTIP_PROPERTY) === 'true');
    }
    $onDestroy() {
        if (this.galleryViewTooltipWatcher) {
            this.$timeout.cancel(this.galleryViewTooltipWatcher);
        }
    }
}
const callActionsToggleViewButton = {
    template,
    bindings: {
        isPatient: '<',
        isGalleryView: '<',
        onButtonClick: '&',
        isGalleryViewTooltipVisible: '<',
        hintTrigger: '@',
        hintTitle: '@',
        updateGalleryViewTooltipVisibility: '&',
    },
    controller: CallActionsToggleViewButtonController,
};
export default angular
    .module('doxy.videoChat.callActions.toggleViewButton', [])
    // call-actions-toggle-view-button
    .component('callActionsToggleViewButton', callActionsToggleViewButton).name;
